export default "__VITE_ASSET__BqFQ3Vug__"